module.exports = __webpack_public_path__ + "static/media/annaberg.a3190fbc.jpg";